import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { createJobPost } from "../../actions/job";
import { getToursById } from "../../actions/vrtour";

import JobMiniStream from "../layout/Employers/JobMiniStream";
import VRTourMiniVideo from "../layout/Employers/VRTourMiniVideo";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";

const CreateJobPost = ({
  match,
  auth: { user },
  isAuthenticated,
  job: { job },
  vrtour: { tours },
  createJobPost,
  getToursById,
}) => {
  const [Job, setJob] = useState({
    title: "",
    salary: 0,
    description: "",
    summary: "",
  });
  const [employmentType, setEmploymentType] = useState("Full-time");
  const [workEnvironment, setWorkEnvironment] = useState("conventional");
  const [keywordText, setKeyword] = useState("");
  const [keywordsText, setKeywords] = useState([]);
  const [responsibility, setResponsibility] = useState("");
  const [responsibilities, setResponsibilities] = useState([]);
  const [qualification, setQualification] = useState("");
  const [qualifications, setQualifications] = useState([]);
  const [benefit, setBenefit] = useState("");
  const [benefits, setBenefits] = useState([]);

  const inputRef = useRef(null);
  const inputRefKeywords = useRef(null);
  const inputRefAlt = useRef(null);
  const inputBenefitRef = useRef(null);

  useEffect(() => {
    getToursById(match.params.channelid);
  }, [getToursById]);

  if (job && job.msg === "Job Successfully Created") {
    return <Redirect to={`/${user.channelid}/content`} />;
  }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.role === "innovator") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <LoggedInNavBlue />
      <div className="flex-all-content-fixed">
        <section className="create-job-main-body">
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue">Job Post Info</p>
              </div>
              <div className="input-label-container">
                <label htmlFor="jobtitle" className="labels-input blue">
                  *Job Title:
                </label>
                <input
                  type="text"
                  name="jobtitle"
                  required
                  value={Job.title}
                  className="input-item"
                  placeholder="Enter Job Title"
                  onChange={(e) => setJob({ ...Job, title: e.target.value })}
                />
              </div>
              <div className="input-label-container">
                <label htmlFor="firstname" className="labels-input blue">
                  *Employment Type:
                </label>
                <select
                  className="jobs-select"
                  name="employmentType"
                  onChange={(e) => setEmploymentType(e.target.value)}
                >
                  <option value="Full-Time">Full-Time</option>
                  <option value="Part-Time">Part-Time</option>
                  <option value="Contract">Contract</option>
                  <option value="Temporary">Temporary</option>
                  <option value="Internship">Internship</option>
                </select>
              </div>
              <div className="input-label-container">
                <label htmlFor="salary" className="labels-input blue">
                  Salary:
                </label>
                <input
                  type="number"
                  name="salary"
                  value={Job.salary}
                  className="input-item"
                  placeholder="Annual Salary"
                  onChange={(e) => setJob({ ...Job, salary: e.target.value })}
                />
              </div>
              <div className="input-label-container">
                <label htmlFor="jobtitle" className="labels-input blue">
                  *Work Environment:
                </label>
                <select
                  className="jobs-select"
                  name="employmentType"
                  onChange={(e) => setWorkEnvironment(e.target.value)}
                >
                  <option value="Conventional">Conventional</option>
                  <option value="Flexible">Flexible</option>
                  <option value="Competitive">Competitive</option>
                  <option value="Creative">Creative</option>
                  <option value="Punitive">Punitive</option>
                  <option value="Practical">Practical</option>
                  <option value="Collaborative">Collaborative</option>
                </select>
              </div>
            </div>
          </div>
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue">Keywords</p>
              </div>
              <div className="input-label-container">
                <label htmlFor="keywords" className="labels-input blue bold">
                  Enter a Keyword:
                </label>
                <input
                  type="text"
                  ref={inputRefKeywords}
                  name="keywords"
                  value={keywordText}
                  className="input-item"
                  placeholder="Enter a Keyword"
                  onChange={(e) => setKeyword(e.target.value)}
                />
                {keywordText !== "" && (
                  <div
                    className="add-keyword background-blue"
                    onClick={() => {
                      setKeywords([...keywordsText, keywordText]);
                      setKeyword("");
                      inputRefKeywords.current.focus();
                    }}
                  >
                    Add Keyword
                  </div>
                )}
              </div>
              {keywordsText.map((word, index) => {
                return (
                  <li className="keywordsArray blue" key={index}>
                    {word}
                    <i
                      className="fas fa-times fa-sm white times-sm mx-10"
                      onClick={() => {
                        keywordsText.splice(index, 1);
                        setKeywords([...keywordsText]);
                      }}
                    ></i>
                  </li>
                );
              })}
            </div>
          </div>
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue">*Description</p>
              </div>
              <div className="flex-only">
                <p className="sub-section blue bold"></p>
              </div>
              <textarea
                className="edit-summary"
                value={Job.description}
                onChange={(e) =>
                  setJob({ ...Job, description: e.target.value })
                }
              ></textarea>
            </div>
          </div>
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue">*Job Summary</p>
              </div>
              <div className="flex-only">
                <p className="sub-section blue bold"></p>
              </div>
              <textarea
                className="edit-summary"
                value={Job.summary}
                onChange={(e) => setJob({ ...Job, summary: e.target.value })}
              ></textarea>
            </div>
          </div>
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue bold">*Job Responsibilities</p>
              </div>
              <div className="input-label-container">
                <label
                  htmlFor="responsibilities"
                  className="labels-input blue bold"
                >
                  Enter a Responsibility:
                </label>
                <input
                  type="text"
                  ref={inputRef}
                  name="responsibilities"
                  value={responsibility}
                  className="input-item"
                  placeholder="Enter a Responsibility"
                  onChange={(e) => setResponsibility(e.target.value)}
                />
                {responsibility !== "" && (
                  <div
                    className="add-responsibility background-blue"
                    onClick={() => {
                      setResponsibilities([
                        ...responsibilities,
                        responsibility,
                      ]);
                      setResponsibility("");
                      inputRef.current.focus();
                    }}
                  >
                    Add Responsibility
                  </div>
                )}
              </div>
              {responsibilities.map((words, index) => {
                return (
                  <li className="job-responsibilities white" key={index}>
                    {words}
                    <i
                      className="fas fa-times fa-sm white times-sm mx-10"
                      onClick={() => {
                        responsibilities.splice(index, 1);
                        setResponsibilities([...responsibilities]);
                      }}
                    ></i>
                  </li>
                );
              })}
            </div>
          </div>
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue">*Job Qualifications</p>
              </div>
              <div className="input-label-container">
                <label
                  htmlFor="qualifications"
                  className="labels-input blue bold"
                >
                  Enter a Qualification:
                </label>
                <input
                  type="text"
                  ref={inputRefAlt}
                  name="qualifications"
                  value={qualification}
                  className="input-item"
                  placeholder="Enter a Qualification"
                  onChange={(e) => setQualification(e.target.value)}
                />
                {qualification !== "" && (
                  <div
                    className="add-responsibility background-blue"
                    onClick={() => {
                      setQualifications([...qualifications, qualification]);
                      setQualification("");
                      inputRefAlt.current.focus();
                    }}
                  >
                    Add Qualification
                  </div>
                )}
              </div>
              {qualifications.map((words, index) => {
                return (
                  <li className="job-responsibilities white" key={index}>
                    {words}
                    <i
                      className="fas fa-times fa-sm white times-sm mx-10"
                      onClick={() => {
                        qualifications.splice(index, 1);
                        setQualifications([...qualifications]);
                      }}
                    ></i>
                  </li>
                );
              })}
            </div>
          </div>
          <div className="items-container">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue">Benefits</p>
              </div>
              <div className="input-label-container">
                <label htmlFor="benefits" className="labels-input blue bold">
                  Enter a Benefit:
                </label>
                <input
                  type="text"
                  ref={inputBenefitRef}
                  name="benefits"
                  value={benefit}
                  className="input-item"
                  placeholder="Enter a Benefit"
                  onChange={(e) => setBenefit(e.target.value)}
                />
                {benefit !== "" && (
                  <div
                    className="add-responsibility background-blue"
                    onClick={() => {
                      setBenefits([...benefits, benefit]);
                      setBenefit("");
                      inputBenefitRef.current.focus();
                    }}
                  >
                    Add Benefit
                  </div>
                )}
              </div>
              {benefits.map((words, index) => {
                return (
                  <li className="job-responsibilities white" key={index}>
                    {words}
                    <i
                      className="fas fa-times fa-sm white times-sm mx-10"
                      onClick={() => {
                        benefits.splice(index, 1);
                        setBenefits([...benefits]);
                      }}
                    ></i>
                  </li>
                );
              })}
            </div>
          </div>
        </section>
        <section className="banner-hero-alt">
          <div className="banner-section-name">
            <h1 className="large-font white">Select VR Tour</h1>
            <Link to={`/${user && user.channelid}/create_vrtour`}>
              <div className="post-action-button">
                <div className="banner-action-items blue">
                  <div className="action-button">
                    <i className="fas fa-street-view fa-lg action-icon-video blue"></i>
                  </div>
                  <p className="action-text">Create New Tour</p>
                </div>
              </div>
            </Link>
          </div>
        </section>
        <section className="main-body">
          {tours && tours.length > 0 ? (
            <div className="created-content">
              {tours &&
                tours.map((vrtours) => {
                  return (
                    <div className="content-container">
                      <div className="stream-result">
                        <VRTourMiniVideo vrtours={vrtours} />
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <p className="empty-content-alt blue">No Content</p>
          )}
        </section>
        <section className="banner-hero-alt">
          <div className="banner-section-name">
            <h1 className="large-font white">Select Job Stream</h1>
            <div className="post-action-button">
              <div className="banner-action-items blue">
                <div className="action-button">
                  <i className="fas fa-minus-circle fa-lg action-icon-stream white"></i>
                </div>
                <p className="action-text">Remove Current Job Stream</p>
              </div>
            </div>
          </div>
        </section>
        <section className="main-body">
          <div className="created-content">
            <div className="content-container">
              <div className="stream-result">
                <Link to="/liveonime/employers/stream_id">
                  <JobMiniStream />
                </Link>
              </div>
            </div>
          </div>
        </section>
        {Job.title !== "" &&
          Job.description !== "" &&
          Job.summary !== "" &&
          responsibilities.length > 0 &&
          qualifications.length > 0 && (
            <div className="submit-changes">
              <button
                className="submit-changes-button background-blue"
                onClick={() =>
                  createJobPost(
                    Job,
                    employmentType,
                    workEnvironment,
                    keywordsText,
                    responsibilities,
                    qualifications,
                    benefits
                  )
                }
              >
                Create Job Post
              </button>
            </div>
          )}
      </div>
    </Fragment>
  );
};

CreateJobPost.propTypes = {
  createJobPost: PropTypes.func.isRequired,
  getToursById: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  job: state.job,
  vrtour: state.vrtour,
});

export default connect(mapStateToProps, { createJobPost, getToursById })(
  CreateJobPost
);
